import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import UserForm from '@galo-monitor/web-containers/forms/company/UserForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const UserModal = (props) => {
  const {
    id,
    open,
    handleClose,
    user,
    onSuccess,
    userDataEndpoint,
    farmsEndpoint,
    rolesEndpoint
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    () => {
      setLoading(false)
      createDialog({
        id: 'error-user',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(isEmpty(user) ? 'register' : 'update')),
            this: toLower(t('user', { howMany: 1 }))
          })  }.`
        }
      })
    },
    [createDialog, t, user]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', { this: t('user', { howMany: 1 }) }) }
      maxWidth="md"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <UserForm
        ref={ formRef }
        user={ user }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
        userDataEndpoint={ userDataEndpoint }
        farmsEndpoint={ farmsEndpoint }
        rolesEndpoint={ rolesEndpoint }
      />
    </Modal>
  )
}

UserModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  user: PropTypes.object,
  userDataEndpoint: PropTypes.string,
  farmsEndpoint: PropTypes.string,
  rolesEndpoint: PropTypes.string
}

UserModal.defaultProps = {
  user: {},
  userDataEndpoint: null,
  farmsEndpoint: '/companies/farms',
  rolesEndpoint: '/companies/roles'
}

export default UserModal
